/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 2/18/2019.
 */

import React from 'react'
import {injectIntl} from 'react-intl';
import {FAULT_STATES} from '../faults/common/FaultsConst'
import { BarChart, Bar, XAxis, YAxis, Tooltip, LabelList, ResponsiveContainer } from 'recharts';

class UsersAssignmentChart extends React.Component {

    //This chart is only able to render once to prevent rerendering when fetching data. If needed some more sophisticated
    //comparison of nextProps to current state can be implemented
    shouldComponentUpdate() {
        if (!this.props.assignedFaults || !this.props.users) {
            return true
        }
        return false
    }

    render() {
        const {intl} = this.props

        if (!this.props.assignedFaults || !this.props.users) {
            return null
        }

        const openedFaults = this.props.assignedFaults.filter((f => f.faultConditionState !== FAULT_STATES.CLOSED_RESOLVED
            && f.faultConditionState !== FAULT_STATES.CLOSED_DUE_TO_LDI_IMPORT &&
            f.faultConditionState !== FAULT_STATES.CLOSED_DUE_TO_INACTIVITY))
        let usersFaults = {}
        openedFaults.forEach(f => {
                if (!usersFaults[f.assignedUser.userName]) {
                    usersFaults[f.assignedUser.userName] = {
                        name: f.assignedUser.displayName,
                        faultsCount: 1,
                    }
                } else {
                    usersFaults[f.assignedUser.userName].faultsCount += 1
                }
        })

        this.props.users.forEach(u => {
            if (!usersFaults[u.userName]) {
                usersFaults[u.userName] = {
                    name: u.displayName,
                    faultsCount: 0,
                }
            }
        })

        const chartData = Object.keys(usersFaults).map(u => ({
            name: usersFaults[u].name,
            value: usersFaults[u].faultsCount,
        }))

        const assignmentsLabel = intl.formatMessage({id: "dashboard.chart.user.assignments"})

        return (
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={chartData}>
                    <XAxis dataKey="name" />
                    <YAxis hide />
                    <Tooltip content={({active, payload}) => {
                        if (active && payload && payload.length) {
                            return (
                                <span>
                                    {payload[0].payload.name}: {payload[0].value}
                                </span>
                            )
                        }
                        return null
                    }} />
                    <Bar dataKey="value" name={assignmentsLabel}>
                        <LabelList dataKey="value" position="top" />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        )
    }
}

export default injectIntl(UsersAssignmentChart)